<script lang="ts">
	import Footer from "./footer.svelte"
	import noty from "noty";
	import {fade, slide, scale} from "svelte/transition"

	interface DB {
		name?: string
		vmax?: string | number,
		leng: string | number,
		mass: string | number,
		typ: string,
		painting: string
	}

	export let db: Array<DB>;

	function hello() {
		new noty({
				type: "info",
				text: "Witaj w Generatorze składów! Jest to <strong>bardzo</strong> wczesna wersja serwisu, jednak jeśli Cię to nie przeraża, wypróbuj mnie!",
				theme: "metroui",
				timeout: 10000
			}).show()
	}
	
	window.onload = hello

	let types = [
		`<optgroup id="EU07" label="EU07">
				<option value="EU07-032">EU07-032</option>
				<option value="EU07-077">EU07-077</option>
				<option value="EU07-088">EU07-088</option>
				<option value="EU07-123E">EU07-123E</option>
				<option value="EU07-141">EU07-141</option>
				<option value="EU07-145">EU07-145</option>
				<option value="EU07-150">EU07-150</option>
				<option value="EU07-222">EU07-222</option>
				<option value="EU07-234">EU07-234</option>
				<option value="EU07-368">EU07-368</option>
				<option value="EU07-409">EU07-409</option>
				<option value="EU07-418">EU07-418</option>
				<option value="EU07-475">EU07-475</option>
				<option value="EU07-515">EU07-515</option>
				<option value="EU07-545">EU07-545</option>
				<option value="EU07-1518">EU07-1518</option>
			  </optgroup>`,
			`<optgroup id="EP07" label="EP07">
				<option value="EP07-338">EP07-338</option>
				<option value="EP07-355">EP07-355</option>
				<option value="EP07-385">EP07-385</option>
				<option value="EP07-391">EP07-391</option>
				<option value="EP07-408">EP07-408</option>
				<option value="EP07-444">EP07-444</option>
				<option value="EP07-1009">EP07-1009</option>
				<option value="EP07-1031">EP07-1031</option>
				<option value="EP07-1038">EP07-1038</option>
				<option value="EP07-1039">EP07-1039</option>
				<option value="EP07-1043">EP07-1043</option>
				<option value="EP07-1054">EP07-1054</option>
				<option value="EP07-1055">EP07-1055</option>
				<option value="EP07-1056">EP07-1056</option>
			  </optgroup>`,
			  `<optgroup id="EP08" label="EP08">
				<option value="EP08-006">EP08-006</option>
				<option value="EP08-006v2">EP08-006v2</option>
			  </optgroup>`,
			  `<optgroup id="ET41" label="ET41">
				<option value="ET41-061">ET41-061</option>
				<option value="ET41-072">ET41-072</option>
				<option value="ET41-144">ET41-144</option>
			  </optgroup>`,
			  `<optgroup id="SM42" label="SM42">
				<option value="SM42-284">SM42-284</option>
				<option value="SM42-329">SM42-329</option>
				<option value="SM42-468">SM42-468</option>
				<option value="SM42-2612">SM42-2612</option>
				<option value="SM42-2648">SM42-2648</option>
			  </optgroup>`,
			  `<optgroup id="A_Vagons" label="Wagony A">
				<option value="158a_PKPIC_A9mnopuz_01">158a_PKPIC_A9mnopuz_01</option>
				<option value="112a_PKPIC_A9ou_01">112a_PKPIC_A9ou_01</option>
				<option value="112a_PRREG_A9ou_02">112a_PRREG_A9ou_02</option>
				<option value="112a_PKP_Adnu_01">112a_PKP_Adnu_01</option>
			  </optgroup>`,
			`<optgroup id="B_Vagons" label="Wagony B">
				<option value="110a_PKP_Bcwxz_01">110a_PKP_Bcwxz_01</option>
				<option value="110a_PKPIC_Bcdu_01">110a_PKPIC_Bcdu_01</option>
				<option value="111a_PKP_Bdnu_02">111a_PKP_Bdnu_02</option>
				<option value="111a_PKPIC_B9nopuvz_01">111a_PKPIC_B9nopuvz_01</option>
				<option value="111a_PKPIC_B9nopuvz_02">111a_PKPIC_B9nopuvz_02</option>
				<option value="111a_PKPIC_B10ou_01">111a_PKPIC_B10ou_01</option>
				<option value="111a_PRREG_B10_01">111a_PRREG_B10_01</option>
				<option value="120a_PRREG_B11pv_01">120a_PRREG_B11pv_01</option>
				<option value="120a_PRREG_B51p_03">120a_PRREG_B51p_03</option>
				<option value="154a_PKPIC_B10mnouz_01">154a_PKPIC_B10mnouz_01</option>
				<option value="504a_PKP_Bckd_01">504a_PKP_Bckd_01</option>
				<option value="612a_PKPIC_BD4osuv_01">612a_PKPIC_BD4osuv_01</option>
				<option value="Bau84_CD_B10nou_01">Bau84_CD_B10nou_01</option>
				<option value="Bau84_PKPIC_B10nou_01">Bau84_PKPIC_B10nou_01</option>
				<option value="Gor77_PKP_Bhp_02">Gor77_PKP_Bhp_02</option>
				<option value="Gor77_PKP_Bhp_03">Gor77_PKP_Bhp_03</option>
				<option value="Gor89_PKP_B16mnopux_03">Gor89_PKP_B16mnopux_03</option>
				<option value="Gor89_PKP_B16mnopux_05">Gor89_PKP_B16mnopux_05</option>
			  </optgroup>`,
			  `<optgroup id="W_Vagons" label="Wagony W">
				<option value="113a_PKP_WRbd_01">113a_PKP_WRbd_01</option>
				<option value="113a_PKPIC_WRbd_01">113a_PKPIC_WRbd_01</option>
			  </optgroup>`,
			  `<optgroup id="S_Vagons" label="Wagony S">
				<option value="504a_PKP_S_02">504a_PKP_S_02</option>
				<option value="426S_PKPC_Sis_01">426S_PKPC_Sis_01</option>
				<option value="426S_PKPC_Sis_02">426S_PKPC_Sis_02</option>
				<option value="426S_PKPC_Sis_03">426S_PKPC_Sis_03</option>
			  </optgroup>`,
			  `<optgroup id="E_Vagons" label="Wagony E">
				<option value="401Zb_PKPC_Eams_01">401Zb_PKPC_Eams_01</option>
				<option value="401Zb_PKPC_Eams_02">401Zb_PKPC_Eams_02</option>
				<option value="401Zb_PKPC_Eams_03">401Zb_PKPC_Eams_03</option>
				<option value="412W_CTL_Eaos_01">412W_CTL_Eaos_01</option>
				<option value="412W_PKPC_Eaos_01">412W_PKPC_Eaos_01</option>
				<option value="412W_PKPC_Eaos_02">412W_PKPC_Eaos_02</option>
				<option value="412W_PKPC_Eaos_03">412W_PKPC_Eaos_03</option>
				<option value="412W_PKPC_Eaos_04">412W_PKPC_Eaos_04</option>
				<option value="412W_PKPC_Eaos_05">412W_PKPC_Eaos_05</option>
				<option value="412W_PKPC_Eaos_06">412W_PKPC_Eaos_06</option>
				<option value="412W_PKPC_Eaos_07">412W_PKPC_Eaos_07</option>
				<option value="412W_PKPC_Eaos_08">412W_PKPC_Eaos_08</option>
				<option value="412W_PKPC_Eaos_09">412W_PKPC_Eaos_09</option>
				<option value="412W_PKPC_Eaos_10">412W_PKPC_Eaos_10</option>
				<option value="412W_PKPC_Eaos_11">412W_PKPC_Eaos_11</option>
				<option value="412W_PKPC_Eaos_12">412W_PKPC_Eaos_12</option>
				<option value="412W_PKPC_Eaos_13">412W_PKPC_Eaos_13</option>
				<option value="412W_PKPC_Eaos_15">412W_PKPC_Eaos_15</option>
				<option value="412W_PKPC_Eaos_16">412W_PKPC_Eaos_16</option>
				<option value="412W_PKPC_Eaos_17">412W_PKPC_Eaos_17</option>
				<option value="429W_PKPC_Eaos-w_01">429W_PKPC_Eaos-w_01</option>
			  </optgroup>`,
			  `<optgroup id="Z_Vagons" label="Wagony Z">
				<option value="29R_CTLL_Zaes_01">29R_CTLL_Zaes_01</option>
				<option value="29R_PKP_Zaekk_01">29R_PKP_Zaekk_01</option>
				<option value="29R_PLPOL_Zaekk_01">29R_PLPOL_Zaekk_01</option>
				<option value="29R_TM_Zaes_01">29R_TM_Zaes_01</option>
			  </optgroup>`,
			  `<optgroup id="U_Vagons" label="Wagony U">
				<option value="29R_PKP_Uah_01">29R_PKP_Uah_01</option>
				<option value="408S_CIECH_Uacs_01">408S_CIECH_Uacs_01</option>
			  </optgroup>`,
			  `<optgroup id="G_Vagons" label="Wagony G">
				<option value="401Ka_PKPC_Gags-t_01">401Ka_PKPC_Gags-t_01</option>
			  </optgroup>`,
			  `<optgroup id="R_Vagons" label="Wagony R">
				<option value="424Z_PKPC_Res_01">424Z_PKPC_Res_01</option>
				<option value="424Z_PKPC_Res_02">424Z_PKPC_Res_02</option>
			  </optgroup>`,
			  `<optgroup id="F_Vagons" label="Wagony F">
				<option value="441V_PKPC_Falns_01">441V_PKPC_Falns_01</option>
				<option value="441V_PKPC_Falns_02">441V_PKPC_Falns_02</option>
				<option value="441V_PKPC_Falns_03">441V_PKPC_Falns_03</option>
				<option value="441V_PKPC_Falns_04">441V_PKPC_Falns_04</option>
				<option value="441V_PKPC_Falns_06">441V_PKPC_Falns_06</option>
				<option value="441V_PKPC_Falns_08">441V_PKPC_Falns_08</option>
			  </optgroup>`
	]

	let locomotives = [
		"EU07",
		"EP07",
		"SM42",
		"EP08",
		"ET41"
	]

	var vagons = []
	var numberOfLocos = 0
	function selectType() {
		// @ts-expect-error
		let type = document.getElementById("rollingStockType").value
		let select = document.getElementById("locos")
		switch (type) {
			case "EU07":
				select.innerHTML = types[0]
				break;
			case "EP07":
				select.innerHTML = types[1]
				break;
			case "EP08":
				select.innerHTML = types[2]
				break;
			case "ET41":
				select.innerHTML = types[3]
				break;
			case "SM42":
				select.innerHTML = types[4]
				break;
			case "A_vagons":
				select.innerHTML = types[5]
				break;
			case "B_vagons":
				select.innerHTML = types[6]
				break;
			case "W_vagons":
				select.innerHTML = types[7]
				break;
			case "S_vagons":
				select.innerHTML = types[8]
				break;
			case "E_vagons":
				select.innerHTML = types[9]
				break;
			case "Z_vagons":
				select.innerHTML = types[10]
				break;
			case "U_vagons":
				select.innerHTML = types[11]
				break;
			case "G_vagons":
				select.innerHTML = types[12]
				break;
			case "R_vagons":
				select.innerHTML = types[13]
				break;
			case "F_vagons":
				select.innerHTML = types[14]
				break;
			default:
				select.innerHTML = `<optgroup id="unknown" label="unknown">
										<option value="unknown">unknown</option>
									</optgroup>`
				break;
		}
	}
	function test() {
		document.getElementById("secondBox").innerHTML = ""
		// @ts-expect-error
		let vagon = document.getElementById("locos").value
		let image = document.getElementById("image")
		if (image.innerHTML.split(`"`)[1] === vagon || vagon == "unknown") return;
		image.innerHTML = `<img alt="${vagon}" src="/images/view/${vagon}.png">`
		document.getElementById("VagonName").innerHTML = vagon
		let index = db.findIndex(name => name.name == vagon)
		if (index == -1) {
			document.getElementById("desc").innerHTML = ""
			document.getElementById("vmax").innerHTML = ""
		} else {
			document.getElementById("desc").innerHTML = `Malowanie: ${db[index].painting}`
			document.getElementById("vmax").innerHTML = `Vmax: ${db[index].vmax}km/h`
			document.getElementById("mass").innerHTML = `Masa: ${db[index].mass} ton`
			document.getElementById("length").innerHTML = `Długość: ${db[index].leng}m`
		}
	}
	function addVagon() {
		// @ts-expect-error
		let tests = document.getElementById("locos").value
		if (tests == "") return;
		let loco = tests.split("-")
		if (locomotives.includes(loco[0]) && numberOfLocos === 2) {
			return new noty({
				type: "error",
				text: "Maksymalna ilość lokomotyw osiągnięta!",
				theme: "metroui",
				timeout: 5000
			}).show()
		}
		if (locomotives.includes(loco[0])) numberOfLocos++
		if (vagons.length > 31) {
			return new noty({
				type: "error",
				text: "Maksymalna ilość wagonów osiągnięta!",
				theme: "metroui",
				timeout: 5000
			}).show()
		}
		vagons.push(tests)
		//manageButton()
		reloadCode()
	}
	function removeLastVagon() {
		if (locomotives.includes(vagons[vagons.length-1].split("-")[0])) numberOfLocos--
		console.log(numberOfLocos)
		vagons.pop()
		//manageButton()
		reloadCode()
	}
	function reloadCode() {
		generateGraphic()
		if (vagons.length !== 0) {
			document.getElementById("result").classList.remove("visually-hidden")
			document.getElementById("skladCode").innerHTML = `<div class="p-1 rounded-3" style="background-color: #1e1e1e;">
																<code id="sklad"></code>
															</div>
															<br><br>`
		}
		if (vagons.length === 0) {
			document.getElementById("skladCode").innerHTML = ""
			document.getElementById("result").classList.add("visually-hidden")
		}
		var vagonSetToDisplay = vagons.join(";")
		document.getElementById("sklad").innerHTML = vagonSetToDisplay
	}
	function generateGraphic() {
		let image = document.getElementById("skladGraphic")
		image.innerHTML = ""
		vagons.forEach(vagonID => {
			image.innerHTML += `<img alt="${vagonID}" src="/images/icons/${vagonID}.png">`
		})
	}
	function copyToClipboard() {
		var vagonSet = vagons.join(";");
		navigator.clipboard.writeText(vagonSet)
	}
	function download() {
		var element = document.createElement('a');
		element.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(vagons.join(";")));
		element.setAttribute('download', `${vagons[0]}.con`);
		element.style.display = 'none';
		document.body.appendChild(element);
		element.click();
		document.body.removeChild(element);
	}
//	function manageButton() {
//		if (vagons.length === 0) {
//			document.getElementById("buttons").innerHTML = ""
//		} else {
//			//document.getElementById("buttons").innerHTML = `<button type="button" class="p-2 btn btn-primary" on:click="{copyToClipboard}">Skopiuj!</button>
//		//<button type="button" class="p-2 btn btn-primary" on:click="{download}">Pobierz!</button>`
//		}
//	}
</script>
<svelte:head>
	<script src="https://cdn.jsdelivr.net/npm/bootstrap@5.0.0-beta3/dist/js/bootstrap.bundle.min.js" integrity="sha384-JEW9xMcG8R+pH31jmWH6WWP0WintQrMb4s7ZOdauHnUtxwoG2vI5DkLtS3qm9Ekf" crossorigin="anonymous"></script>
	<link rel="preconnect" href="https://fonts.gstatic.com">
	<link href="https://cdn.jsdelivr.net/npm/bootstrap@5.0.0-beta3/dist/css/bootstrap.min.css" rel="stylesheet" integrity="sha384-eOJMYsd53ii+scO/bJGFsiCZc+5NDVN2yr8+0RDqr0Ql0h+rP48ckxlpbzKgwra6" crossorigin="anonymous">
	<link defer href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.15.1/css/all.min.css" rel="stylesheet" />
	<link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/noty/3.1.4/noty.css" integrity="sha512-NXUhxhkDgZYOMjaIgd89zF2w51Mub53Ru3zCNp5LTlEzMbNNAjTjDbpURYGS5Mop2cU4b7re1nOIucsVlrx9fA==" crossorigin="anonymous">
</svelte:head>
<header class="text-white pt-5 text-center d-inline-block">
	<h1>Generator składów</h1>
</header>
<main class="flex-shrink-0  d-inline-flex pb-5">
	<div class="container text-white text-center">
		<div class="row">
			<div class="col mx-5 border py-5 rounded-3 border-radius-lg border-dark" style="background-color: rgba(0, 0, 0, 0.35);">
				<div class="mb-5">
					<label style="display: block; align-items: center;" for="rollingStockType">Wybierz typ taboru:</label>
					<select style="background-color: #2b2a2a; color: white" id="rollingStockType" name="rollingStockType" on:click="{selectType}">
						  	<option value="EU07">EU07</option>
						  	<option value="EP07">EP07</option>
							<option value="EP08">EP08</option>
							<option value="ET41">ET41</option>
							<option value="SM42">SM42</option>
						  	<option value="A_vagons">Wagony A</option>
							<option value="B_vagons">Wagony B</option>
							<option value="E_vagons">Wagony E</option>
							<option value="F_vagons">Wagony F</option>
							<option value="G_vagons">Wagony G</option>
							<option value="W_vagons">Wagony W</option>
							<option value="S_vagons">Wagony S</option>
							<option value="U_vagons">Wagony U</option>
							<option value="R_vagons">Wagony R</option>
							<option value="Z_vagons">Wagony Z</option>
					</select>
				</div>
				<div class="m-5">
					<label style="display: block; align-items: center;" for="locos">Wybierz wagon/lokomotywe:</label>
					<select style="background-color: #2b2a2a; color: white;" size="5" name="locos" id="locos" on:click="{test}">
						<optgroup id="EU07" label="EU07">
							<option value="EU07-032">EU07-032</option>
							<option value="EU07-077">EU07-077</option>
							<option value="EU07-088">EU07-088</option>
							<option value="EU07-145">EU07-145</option>
							<option value="EU07-150">EU07-150</option>
							<option value="EU07-222">EU07-222</option>
							<option value="EU07-234">EU07-234</option>
							<option value="EU07-242">EU07-242</option>
							<option value="EU07-368">EU07-368</option>
							<option value="EU07-409">EU07-409</option>
							<option value="EU07-475">EU07-475</option>
							<option value="EU07-515">EU07-515</option>
							<option value="EU07-1518">EU07-1518</option>
						  </optgroup>
					</select>
				</div>
				<div class="mt-5">
					<button type="button" class="m-2 btn btn-primary" on:click="{addVagon}">Dodaj!</button>
					<button type="button" class="m-2 btn btn-danger" on:click="{removeLastVagon}">Usuń ostatni wagon</button>
				</div>
			</div>
			<div class="col mx-5 border p-5 rounded-3 border-dark" style="background-color: rgba(0, 0, 0, 0.35);">
				<span id="secondBox">
					Lorem ipsum dolor sit amet, consectetur adipiscing elit. Praesent vel consequat quam. Etiam at turpis in mi luctus eleifend. Phasellus volutpat, felis ut vestibulum interdum, tortor lacus feugiat mi, at sagittis libero magna eget dui. Vestibulum magna tellus, facilisis at auctor eu, sollicitudin vitae odio. Nunc vestibulum lorem a dictum sodales. Vivamus lobortis cursus lorem eget luctus. Morbi vel est lorem.
					
					Orci varius natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Fusce vulputate ante mi, rhoncus porta neque venenatis nec. Vestibulum sed nulla ut neque ultrices lacinia. Vestibulum feugiat metus nulla, eget maximus neque ullamcorper ut. Integer scelerisque.</span>
				<div>
					<div class="p-2">
						<span id="image"></span>
					</div>
					<div class="p-2">
						<!-- svelte-ignore a11y-missing-content -->
						<h2 id="VagonName"></h2>
						<div>
							<p id="desc"></p>
							<p id="vmax"></p>
							<p id="mass"></p>
							<p id="length"></p>
						</div>
					</div>					
				</div>
			</div>
		</div>
		<br>
		
		<br><br>
		
		<div id="result" class="row visually-hidden mx-auto" style="min-width: 50rem; max-width: 50rem;">
			<div class="col mx-5 border py-5 rounded-3 border-radius-lg border-dark" style="background-color: rgba(0, 0, 0, 0.35);">
				<div style="overflow: auto; white-space: nowrap;" in:fade out:fade>
					<span id="skladGraphic"></span>
				</div>
				<br><br>
				<span id="skladCode"></span>
				<div>
					<button type="button" class="p-2 btn btn-primary" on:click="{copyToClipboard}">Skopiuj!</button>
					<button type="button" class="p-2 btn btn-primary" on:click="{download}">Pobierz!</button>
				</div>
			</div>
		</div>
	</div>
</main>
<Footer/>